import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export default function HomeSectionDescription({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "text-zinc-400 leading-relaxed   space-y-5  break-keep",
        className
      )}
    >
      {children}
    </div>
  );
}
